<div class="modal-header justify-content-center">
  <h4 class="title title-up">Multimedia</h4>
</div>
<div class="modal-body">
  <app-media-explorer [tree]="cms.tree | async" [(path)]="mediaPath" [(select)]="mediaSelect" [multi]="false"> </app-media-explorer>
</div>
<br />
<div class="modal-footer">
  <button type="button" class="btn btn-sm mx-3" (click)="modal.close()">Cancel</button>
  <button type="button" class="btn btn-sm mx-3 btn-primary" (click)="modal.close(mediaSelect)">Select</button>
</div>
